import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialStack = {
  factory: EElement({
    id: '43370b55-f15d-3f8d-904e-057535e7250b',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('d14d0619-f01f-6124-487a-3a609e8cbffa')]),
      children: EList([
        EElement({
          id: '4872da02-ae64-e66c-7f99-4ea06b6245c0',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '69fc717d-d489-e628-edd1-e29649c7fa73',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('5dd1be3d-2f5d-a06d-3573-9a397c03fc60'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'e8285291-94d9-201d-ed72-3e33ad3a2033',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('a143a0d9-6b83-0681-ccf8-ecc56f947a28'),
                        ]),
                        children: EList([
                          EElement({
                            id: '34896264-58a2-0895-3520-f9b1a0142966',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              styleBlockIds: EList([
                                EText('1781597d-0cce-1201-af17-2f71318913d0'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '34896264-58a2-0895-3520-f9b1a0142967',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Testimonial introduction copy goes here, lorem ipsum dolor sit amet.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0e394356-bc3d-ec13-23f5-cee86b2bc942',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('ad54c0d5-5e82-3858-0d26-49585c42edf6'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0e394356-bc3d-ec13-23f5-cee86b2bc943',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CLorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '2befb101-b24f-07c1-e5b0-a5cd8ecfeadd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('3a3e6ce7-71c8-0b2f-c870-c0447dec085c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '2befb101-b24f-07c1-e5b0-a5cd8ecfeade',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730d8b9765baa36e65498e"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                      EText(
                                        'ef5c9902-3a40-6a1b-9c7a-521d48c5e000'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '2befb101-b24f-07c1-e5b0-a5cd8ecfeadf',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '57e026df-2e6b-a735-2320-7fb8f471aced',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          styleBlockIds: EList([
                                            EText(
                                              '7986b44a-b827-b1d8-8508-c92109cfa10b'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '57e026df-2e6b-a735-2320-7fb8f471acee',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '2befb101-b24f-07c1-e5b0-a5cd8ecfeae2',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          styleBlockIds: EList([
                                            EText(
                                              '9cab6300-eb80-0e06-a58b-4ef4d41d66ff'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '2befb101-b24f-07c1-e5b0-a5cd8ecfeae3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Former VP of ads at Company'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'd14d0619-f01f-6124-487a-3a609e8cbffa',
      type: 'class',
      name: 'Testimonial Stack',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '5dd1be3d-2f5d-a06d-3573-9a397c03fc60',
      type: 'class',
      name: 'Testimonial Card Three',
      comb: '',
      styleLess:
        'padding-top: 64px; padding-right: 42px; padding-bottom: 64px; padding-left: 42px; background-color: hsla(216, 33.33%, 97.06%, 1.00); text-align: center;',
      children: [],
      variants: {tiny: {styleLess: 'padding-right: 24px; padding-left: 24px;'}},
    },
    {
      _id: 'a143a0d9-6b83-0681-ccf8-ecc56f947a28',
      type: 'class',
      name: 'Testimonial Card Content',
      comb: '',
      styleLess:
        'position: relative; display: flex; max-width: 580px; margin-right: auto; margin-left: auto; flex-direction: column; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: '1781597d-0cce-1201-af17-2f71318913d0',
      type: 'class',
      name: 'Testimonial Card Heading',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: 'ad54c0d5-5e82-3858-0d26-49585c42edf6',
      type: 'class',
      name: 'Testimonial Text Three',
      comb: '',
      styleLess: 'font-size: 24px; line-height: 32px;',
      children: [],
      variants: {small: {styleLess: 'font-size: 20px; line-height: 28px;'}},
    },
    {
      _id: '3a3e6ce7-71c8-0b2f-c870-c0447dec085c',
      type: 'class',
      name: 'Testimonial Info Four',
      comb: '',
      styleLess:
        'display: flex; margin-top: 24px; flex-direction: column; align-items: center; text-align: center;',
      children: [],
      variants: {
        tiny: {styleLess: 'flex-direction: column; text-align: center;'},
      },
    },
    {
      _id: 'eee554db-e006-8dc8-ae3d-0f25db8d5e13',
      type: 'class',
      name: 'Testimonial Image',
      comb: '',
      styleLess:
        'width: 60px; height: 60px; margin-right: 16px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: ['ef5c9902-3a40-6a1b-9c7a-521d48c5e000'],
      variants: {},
    },
    {
      _id: 'ef5c9902-3a40-6a1b-9c7a-521d48c5e000',
      type: 'class',
      name: 'Centered',
      comb: '&',
      styleLess:
        'width: 80px; height: 80px; margin-right: 0px; margin-bottom: 16px;',
      children: [],
      variants: {},
    },
    {
      _id: '7986b44a-b827-b1d8-8508-c92109cfa10b',
      type: 'class',
      name: 'Testimonial Author Name Three',
      comb: '',
      styleLess: 'margin-bottom: 10px;',
      children: [],
      variants: {},
    },
    {
      _id: '9cab6300-eb80-0e06-a58b-4ef4d41d66ff',
      type: 'class',
      name: 'Testimonial Title',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
